import { __assign, __awaiter, __generator } from "tslib";
import { useCallback, useEffect } from "react";
import { useAuthData, DEFAULT_AUTH_DATA_VALUES, } from "../providers/AuthDataProvider";
import { useViewer, ACCESS_STATUSES, } from "../providers/ViewerProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { callAPI } from "../helpers/callAPI";
import { languageAPIHeader } from "../helpers/languageAPIHeader";
import { getUrlsInSupportedFormat } from "../helpers/getUrlsInSupportedFormat";
import { findImagesByAttribute } from "../helpers/findImagesByAttribute";
import { MEDIA_OUTPUT_CHANNEL } from "../constants";
export var useGet360Data = function () {
    var _a = useAuthData(), token = _a.token, _b = _a.isSupportWebp, isSupportWebp = _b === void 0 ? DEFAULT_AUTH_DATA_VALUES.isSupportWebp : _b;
    var _c = useTranslations(), defaultLanguage = _c.defaultLanguage, language = _c.language;
    var _d = useViewer(), siteId = _d.siteId, defaultMedia = _d.defaultMedia, setViewerData = _d.setViewerData;
    var demoMedia = [
        (defaultMedia === null || defaultMedia === void 0 ? void 0 : defaultMedia.demo360) || {},
    ];
    var fetchViewerData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var configuration, axiosResponse, images_1, thingEquirectangularMedia_1, siteName_1, status_1, introTeaserImage, introTeaserUrls_1, galleryImagesMedia, processedGalleryImages_1, error_1;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!token || !defaultLanguage || !language) {
                        return [2 /*return*/];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    configuration = {
                        method: "POST",
                        url: "/sites/paul_live/".concat(siteId, "/360images"),
                        cache: true,
                        headers: __assign({ Authorization: "Bearer ".concat(token) }, languageAPIHeader({ defaultLanguage: defaultLanguage, language: language })),
                    };
                    return [4 /*yield*/, callAPI(configuration)];
                case 2:
                    axiosResponse = (_g.sent()).data;
                    if (!Object.keys(axiosResponse).length) {
                        throw new Error("No data");
                    }
                    images_1 = axiosResponse.images, thingEquirectangularMedia_1 = axiosResponse.thingEquirectangularMedia, siteName_1 = axiosResponse.siteName;
                    status_1 = thingEquirectangularMedia_1 || ACCESS_STATUSES.demo;
                    introTeaserImage = findImagesByAttribute(images_1, "outputChannel", MEDIA_OUTPUT_CHANNEL.entry);
                    introTeaserUrls_1 = getUrlsInSupportedFormat({
                        url: (_f = (_e = (_d = (_c = (_b = (_a = introTeaserImage[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.attributes) === null || _c === void 0 ? void 0 : _c.rsInternalDigitalAssetOriginalAssetUrl) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.value,
                        isSupportWebp: isSupportWebp,
                    });
                    galleryImagesMedia = findImagesByAttribute(images_1, "outputChannel", MEDIA_OUTPUT_CHANNEL.gallery);
                    processedGalleryImages_1 = galleryImagesMedia === null || galleryImagesMedia === void 0 ? void 0 : galleryImagesMedia.map(function (item) {
                        var _a, _b, _c, _d, _e;
                        var galleryImagesUrlsMedia = getUrlsInSupportedFormat({
                            url: item.data.attributes.rsInternalDigitalAssetOriginalAssetUrl
                                .values[0].value,
                            isSupportWebp: isSupportWebp,
                        });
                        return {
                            urls: galleryImagesUrlsMedia,
                            attributes: {
                                pan: (_a = item.data.attributes.pan) === null || _a === void 0 ? void 0 : _a.values[0].value,
                                tilt: (_b = item.data.attributes.tilt) === null || _b === void 0 ? void 0 : _b.values[0].value,
                                // roll: item.data.attributes.roll?.values[0].value, // uncomment if somewhere needed and BE returns
                                // isEquirectangular:
                                //   item.data.attributes.isEquirectangular?.values[0].value, // uncomment if somewhere needed and BE returns
                                pitch: (_c = item.data.attributes.pitch) === null || _c === void 0 ? void 0 : _c.values[0].value,
                                yaw: (_d = item.data.attributes.yaw) === null || _d === void 0 ? void 0 : _d.values[0].value,
                                title: (_e = item.data.attributes.title) === null || _e === void 0 ? void 0 : _e.values[0].value,
                            },
                            id: item.id,
                        };
                    });
                    setViewerData(function (prev) {
                        var newData = __assign(__assign({}, prev), { responseData: __assign(__assign({}, prev.responseData), { thingEquirectangularMedia: thingEquirectangularMedia_1, images: images_1, siteName: siteName_1 }), siteName: siteName_1, status: status_1, isLoadingPreview: false, previewUrl: introTeaserUrls_1.preview, 
                            // GalleryImages
                            media: status_1 === ACCESS_STATUSES.content
                                ? processedGalleryImages_1
                                : demoMedia, activeMedia: status_1 === ACCESS_STATUSES.content
                                ? processedGalleryImages_1[0]
                                : demoMedia[0] });
                        return newData;
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _g.sent();
                    // eslint-disable-next-line no-console
                    console.log("Something went wrong with API call");
                    setViewerData(function (prev) { return (__assign(__assign({}, prev), { isLoadingPreview: false, status: ACCESS_STATUSES.demo })); });
                    // eslint-disable-next-line no-console
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [token, defaultLanguage, language, siteId]);
    useEffect(function () {
        fetchViewerData().then();
    }, [fetchViewerData]);
};
